import { styled, Box, TextField, Typography } from '@mui/material';
import color from 'src/theme/color';

export const ServicesCard = styled(Box)({
    width: '500px',
    minHeight: '400px',
    background: color.blackLight,
    borderRadius: '16px',
    position: 'relative',
    color: color.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)'
});

export const ButtonContentBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
    margin: '0 auto'
});

export const TitleContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
});

export const StyledTextField = styled(TextField)({
    '& .MuiInputBase-root': {
        height: '50px'
    }
});

export const MultilineTextField = styled(TextField)({
    '& .MuiInputBase-root': {
        minHeight: '50px',
        height: 'auto'
    }
});

export const FlexContainer = styled(Box)({
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
    position: 'relative'
});

export const SkillChip = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isHovered'
})<{ isHovered?: boolean }>(({ isHovered }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    borderRadius: '20px',
    backgroundColor: isHovered
        ? color.yellowTransparent1
        : color.greyTransparent,
    color: color.white80,
    '&:hover': {
        backgroundColor: color.yellowTransparent1,
        cursor: 'pointer',
        transition: 'background-color 0.3s'
    }
}));

export const AddButton = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'isHovered'
})<{ isHovered?: boolean }>(({ isHovered }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    borderRadius: '20px',
    backgroundColor: isHovered ? color.yellow : color.yellowTransparent,
    color: isHovered ? color.white : color.yellow,
    marginLeft: 'auto',
    '&:hover': {
        cursor: 'pointer'
    }
}));

export const ConnectChipActive = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    borderRadius: '20px',
    border: `1px solid ${color.yellow60}`,
    backgroundColor: color.greyTransparent,
    color: color.white80,
    position: 'relative'
});

export const TeamMemberChip = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px',
    borderRadius: '20px',
    color: color.white80,
    backgroundColor: color.greyTransparent
});

export const TeamMemberRole = styled('span')({
    marginLeft: '8px',
    color: color.white50
});

export const IconStyle = {
    marginLeft: '8px',
    width: '17px',
    height: '17px'
};

export const AddIconStyle = {
    marginLeft: '8px',
    width: '18px',
    height: '18px'
};

export const CheckIconStyle = {
    position: 'absolute',
    top: '-4px',
    right: '-4px',
    width: '12px',
    height: '12px',
    fill: color.yellow
};

export const CloseIconStyle = (isHovered: boolean) => ({
    marginLeft: '4px',
    marginTop: '2px',
    fill: isHovered ? color.yellowTransparent2 : color.greyIcon,
    cursor: 'pointer'
});

export const ButtonTextBox = styled(Box)<{ $isHovered: boolean }>(
    ({ $isHovered }) => ({
        position: 'relative',
        transition: 'transform 0.3s ease-in-out',
        transform: $isHovered ? 'translateX(-8px)' : 'translateX(0)',
        fontWeight: 500,
        fontSize: '16px',
        display: 'inline-flex',
        alignItems: 'center'
    })
);

export const ButtonIconBox = styled(Box)<{ $isHovered: boolean }>(
    ({ $isHovered }) => ({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '2px',
        opacity: $isHovered ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
        position: 'relative',
        right: 'auto'
    })
);

export const ContentContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '30px 20px',
    height: '100%'
});

export const HeaderContainer = styled(Box)({
    marginBottom: '30px'
});

export const ThankYouTitle = styled(Typography)({
    marginBottom: '16px'
});

export const ImageContainer = styled(Box)({
    marginBottom: '30px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
});

export const ProjectImage = styled('img')({
    maxWidth: '200px',
    height: 'auto'
});

export const BodyText = styled(Typography)({
    textAlign: 'left',
    fontSize: '16px',
    color: color.white80,
    marginBottom: '40px'
});
